/* eslint-disable prettier/prettier */
export default $axios => () => ({
    getHomeNews() {
        return $axios.$get("/PortalInformation/getInformationFour");
    },
    getAds(params) {
        return $axios.$get("/ads/getAds", { params });
    },
    getDynamic() {
        return $axios.$get("/index/dynamic");
    },
    getHotGoods(params) {
        return $axios.$get("/supplyAndDemand/getHotGoods", { params });
    },
    selectHotGoodList(params) {
        return $axios.$get("/supplyAndDemand/selectHotGoodList", { params });
    },
    selectHotDemandList(params) {
        return $axios.$get("/supplyAndDemand/selectHotDemandList", { params });
    },
    getHotDemand(params) {
        return $axios.$get("/supplyAndDemand/getHotDemand", { params });
    },
    selectNumInformationListByTypeId(params) {
        return $axios.$get("/PortalInformation/selectNumInformationListByTypeId", {
            params
        });
    },
    getTopTypeInformation(params) {
        return $axios.$get("/PortalInformation/getTopTypeInformation", {
            params
        });
    },
    getTopInformation(params) {
        return $axios.$get("/PortalInformation/getTopInformation", { params });
    },
    getBannerInformation(params) {
        return $axios.$get("/PortalInformation/getBannerInformation", { params });
    },
    getInformationType(params) {
        return $axios.$get("/PortalInformation/getTypeName", {
            params
        });
    },
    getInformationById(params) {
        return $axios.$get("/PortalInformation/getInformationById", { params });
    },
    getPageInformation(params) {
        return $axios.$get("/PortalInformation/getPageInformation", { params });
    },
    setPasswordForSignUp(query, data) {
        return $axios.$post(`/setPasswordForSignUp?randomCode=${query}`, data);
    },

    setPasswordForSignUp2(query, query2, data) {
        return $axios.$post("/setPasswordForSignUp2?randomCode=" + query + "&tenantCode=" + query2, data);
    },

    getContractSettingList(query) {
        return $axios.$post(`/contractRegistration/getRegOptionsFileByPage?optionsType=${query}`);
    },
    // 获取实验室列表信息
    getAllLaboratoryInfos() {
        return $axios.get("/laboratoryAchievement/getAllLaboratoryInfo");
    },
    // 获取全部成果形式
    getLaboratoryForm() {
        return $axios.$get("/laboratoryAchievement/getAllForm");
    },
    // 获取全部实验室
    getAllLaboratory() {
        return $axios.$get("/laboratoryAchievement/getAllLaboratory");
    },
    // 获取全部成果成熟度
    getAllMaturity() {
        return $axios.$get("/laboratoryAchievement/getAllMaturity");
    },
    // 获取全部知识产权情况
    getAllSituation() {
        return $axios.$get("/laboratoryAchievement/getAllSituation");
    },
    // 获取全部实验室成果领域
    getAllTech() {
        return $axios.$get("/laboratoryAchievement/getAllTech");
    },
    // 获取实验室成果详情
    getLaboratoryAchievement(params) {
        return $axios.$get("/laboratoryAchievement/getLaboratoryAchievement", {
            params
        });
    },
    // 分页获取实验室成果
    getLaboratoryAchievementPage(params) {
        return $axios.$get("/laboratoryAchievement/getLaboratoryAchievementPage", { params });
    },
    getFloatWindowList() {
        return $axios.$get("/indexFloat/getIndexFloatList");
    },
    // 获取调查问卷结果
    getGoodsInvestigationById(params) {
        return $axios.$get("/search/getGoodsInvestigationById", {
            params
        });
    },
    // 调查问卷投票
    addGoodsInvestigation(data) {
        return $axios.$post(`/search/addGoodsInvestigation`, data);
    },
    // 已出售商品专题页
    getGoodsSoldList(params) {
        return $axios.$get("/goodsSold/goods", {
            params
        });
    },
    getGoodsSoldTotal(params) {
        return $axios.$get("/goodsSold/orderTotal", {
            params
        });
    },
    getGoodsShops(params) {
        return $axios.$get("/goodsSold/shops", {
            params
        });
    },
    getNotice(params) {
        return $axios.$get("/index/getNotice", {
            params
        });
    },
    getHotGoodsMap(params) {
        return $axios.$get("/supplyAndDemand/getHotGoodsMap", {
            params
        });
    },
    searchAll(params) {
        return $axios.$post("/search/global", params);
    },

    getHotShop(params) {
        return $axios.$get("/shop/findSuperiorShop", {
            params
        });
    },
    getYRDList(params) {
        return $axios.$get("/activityTopic/getAllRelatedGoodsPage", {
            params
        });
    },
    selectActivityPatentDtoPage01(params) {
        return $axios.$get("/activityTopic/selectActivityPatentDtoPage01", {
            params
        });
    },
    selectActivityPatentDtoPage01Js(params) {
        return $axios.$get("/activityTopic/selectActivityPatentDtoPage01Js", {
            params
        });
    },
    selectActivityPatentDtoPage01Nj(params) {
        return $axios.$get("/activityTopic/selectActivityPatentDtoPage01Nj", {
            params
        });
    },
    getYRDShopList(params) {
        return $axios.$get("/activityTopic/getRelatedShopInfo", {
            params
        });
    },
    getTopStatics(params) {
        return $axios.$get("/activityTopic/getTopStatics", {
            params
        });
    },
    getYRDHighTechList(params) {
        return $axios.$get("/activityTopic/getActivityTopicHighCode", {
            params
        });
    },
    getYRDHotGoodsList(params) {
        return $axios.$get("/activityTopic/getAllHotGoodsList", {
            params
        });
    },
    getGoodsInfo(params) {
        return $axios.$get("/search/getGoodsInfo", {
            params
        });
    },
    judgeCollected(params) {
        return $axios.$get("/search/judgeCollected", {
            params
        });
    },
    getSolveRankList(params) {
        return $axios.$get("/crowdsourceDemand/getTalentsPageList", {
            params
        });
    },
    getJtopHotDemand(params) {
        return $axios.$get("/activity/getActivityCrowdSourceDemandsByHot", {
            params
        });
    },
    getJtopHighCode(params) {
        return $axios.$get("/activity/getHighCooperationTree", {
            params
        });
    },
    getJtopDemands(params) {
        return $axios.$get("/activity/getCrowdSourceDemands", {
            params
        });
    },

    // 热门需求更改
    getJtopDemands2(params) {
        return $axios.$get("/activity/getCrowdSourceDemands2", {
            params
        });
    },

    // 第三届创新挑战季省内地区更改
    getJtopDemands4(params) {
        return $axios.$get("/activity/getCrowdSourceDemands4", {
            params
        });
    },

    // 第三届创新挑战季查询全部需求长江三角洲
    getJtopSourceDemands3(params) {
        return $axios.$get("/activity/getCrowdSourceDemands3", {
            params
        });
    },

    getAssociatedGoodsByCrowdSource(params) {
        return $axios.$get("/search/getAssociatedGoodsByCrowdSource", {
            params
        });
    },
    getUserListByActivityId(params) {
        return $axios.$get("/activity/getUserDataCountByActivityId", {
            params
        });
    },
    getAllUserByActivityId(params) {
        return $axios.$get("/activity/getAllUserDataByActivityId", {
            params
        });
    },
    getAllUserByActivityId2(params) {
        return $axios.$get("/activity/getUserDataByActivityId", {
            params
        });
    },
    getActivityDetail(params) {
        return $axios.$get("/activity/activityDetail", {
            params
        });
    },
    getActivityCompleteDemands(params) {
        return $axios.$get("/activity/getCompleteCrowdSourceDemandsByActivityId", {
            params
        });
    },
    getSolvedCrowdSourceTotal(params) {
        return $axios.$get("/crowdSourceComplete/getCompleteTotal", {
            params
        });
    },
    getSolvedCrowdSourceDemandList(params) {
        return $axios.$get("/crowdSourceComplete/getCrowdSourceDemandList", {
            params
        });
    }
    ,
    getNotice1(params) {
        return $axios.$get("/index/getNotice", {
            params
        });
    },


    // 保存log - 2021-08-20
    saveDownloadLog(params) {
        return $axios.$get(`/helpCentre/saveDownloadLog`, {
            params
        });
    },

    //   竞拍列表
    getAllTarget(params) {
        // https://bid.jstec.com.cn/portal
        return $axios.$get("/tradingHall/getAllTarget", {
            params
        });
    },
    // // 资产单例专题页商品查询
    // getAssetThemeGoodQuery(params) {
    //     return $axios.$get("/themeGoods/getAssetThemeGoodQuery", {
    //         params
    //     });
    // },
    // // 资产单例专题页公示查询
    // getPublicityListingsPageByActivity(params) {
    //     return $axios.$get("/publicity/getPublicityListingsPageByActivity", {
    //         params
    //     });
    // },
    // 交易公示列表
    //   getOrderGoods(params){
    //     return $axios.$get(`/publicity/getOrderGoods`,{
    //         params
    //     })
    //   },


        getActivityById(params) {
            console.log("getActivityById", params);
        return $axios.$get("/commonActivity/getActivityById", { params });
    },

})
